<template>
    <rkm-modal
        large
        ref="RkmModal"
        title="Vínculo - Fabricante (ConectaSUS)"
    >
        <rkm-form
            v-if="model"
            ref="RkmForm"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-input
                        disabled
                        :value="`${model.nome}${model.cnpj ? ` - ${model.cnpj}` : ''}`"
                        label="Fabricante (Cliente)"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-select
                        :options="form.conectasusFabricantes"
                        :validations="validations.conectasusFabricante"
                        label="Fabricante (ConectaSUS)"
                        show-default-option
                        text-field="descricao"
                        v-model="model.conectasusFabricanteId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                color="primary"
                @click="save"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, repository, stringCase, unmask} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                conectasusFabricante: {required: true},
            }
        },
    },
    created() {
        this.repositories = {
            fabricante: this.getConectaSusRepository('webService.almoxarifado.cliente.fabricante'),
        }
    },
    data: () => ({
        fabricanteId: null,
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(fabricanteId) {
            this.fabricanteId = fabricanteId
            this.form = null
            this.model = null

            this.load()
            this.$refs.RkmModal.show()
        },
        load() {
            this.setLoading()

            this.repositories.fabricante.edit(this.fabricanteId)
                .then(response => {
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.setLoading()

                    const request = {
                        conectasusFabricanteId: this.model.conectasusFabricanteId,
                        nome: this.model.nome,
                        cnpj: this.model.cnpj ? this.unMaskCnpj(this.model.cnpj) : null,
                    }

                    this.repositories.fabricante.update(this.fabricanteId, this.camelObjectKeysToSnakeRecursive(request))
                        .then(response => {
                            this.showSaveNotification()
                            this.$emit('saved', response)
                            this.$refs.RkmModal.hide()
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
    },
    mixins: [error, repository, stringCase, unmask],
}
</script>